import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useRouter } from 'next/router';

import { getGenericTrackingData } from '@finanzcheck/one-segment';
import { isRevocationPage } from 'lib/router/route-helper';
import { TrackingEvent } from 'lib/tracking/events';
import { track } from 'lib/tracking/track';

export interface FooterLink {
  caption: string;
  href: string;
}

interface Props {
  oneTrustHandler?: () => void;
  links: FooterLink[];
}

const StyledLink = ({
  href,
  children,
  onClick,
}: {
  href?: string;
  children: string;
  onClick?: () => void;
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', cursor: 'pointer' }}
    onClick={onClick}
    sx={{
      color: 'grey.900',
      pb: (theme) => ({ xs: theme.spacing(2), sm: theme.spacing(0.5) }),
      flexBasis: { xs: '50%', sm: 'inherit' },
      fontSize: (theme) => theme.spacing(1.75),

      ':hover': {
        color: (theme) => theme.palette.grey[500],
      },
    }}
  >
    {children}
  </Link>
);

const Links = ({ oneTrustHandler, links }: Props) => {
  const { pathname } = useRouter();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', md: 'flex-end' },
        gap: (theme) => ({ sm: theme.spacing(2) }),
      }}
    >
      {links.map((link) => (
        <StyledLink key={link.caption} href={link.href}>
          {link.caption}
        </StyledLink>
      ))}
      {oneTrustHandler && (
        <StyledLink onClick={oneTrustHandler}>Cookies</StyledLink>
      )}
      {!isRevocationPage(pathname) && (
        <StyledLink
          href="/widerruf"
          onClick={() =>
            track(TrackingEvent.WIDERRUF_BUTTON_CLICKED, {
              ...getGenericTrackingData(),
              action: 'click',
              buttonName: 'Widerruf',
              buttonLocation: pathname,
            })
          }
        >
          Widerruf
        </StyledLink>
      )}
    </Box>
  );
};

export { Links };
